import "./StyleButtonHint.css"
import {HandySvg} from "handy-svg";

function ButtonPlusImg({ className, text, id, funck, img, divModifier, classImg, disabled }) {
    return (
        <div className={divModifier}>
            <button
                type="button"
                className={`button--hint__red ${className}`}
                id={id}
                disabled={disabled}
                onClick={funck}
            >
                {text}
            </button>
            <HandySvg src={img} className={classImg}/>
        </div>
    )
}

export default ButtonPlusImg